import React from "react";
import { useCountdownStore } from "../../../../stores/use-countdown-store";
import { CountdownEditorContainer } from "./styles";
import Design from "../designs/Design";

import Actions from "../actions/Actions";

function CountdownEditor() {
  const { data } = useCountdownStore((state) => ({ data: state.data }));

  return (
    <CountdownEditorContainer>
      <Design data={data} viewMode="edit" isEditable={true} />
      <Actions />
    </CountdownEditorContainer>
  );
}

export default CountdownEditor;
